import React, { useState } from 'react';
import { HiMenu, HiX } from 'react-icons/hi';

const Navbar = () => {
  const links = ['About', 'Education', 'Experience', 'Projects', 'Resume'];
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed top-5 w-full z-50">
      <div className="flex justify-center">
        {/* Wrapper for desktop nav and mobile menu button */}
        <div className="flex items-center bg-[#0f0f0f] border border-gray-700 px-6 py-2 rounded-full shadow-md backdrop-blur-md">
          {/* Desktop Navigation */}
          <ul className="hidden md:flex">
            {links.map((link, index) => (
              <li key={index} className="mx-2">
                <a
                  href={`#${link.toLowerCase().replace(/[^a-z]/g, '')}`}
                  className="text-sm text-white px-3 py-1 rounded-full transition duration-300 hover:bg-white hover:text-black"
                >
                  {link}
                </a>
              </li>
            ))}
          </ul>

          {/* Mobile Toggle */}
          <button
            className="md:hidden flex items-center gap-2 text-white text-base font-semibold"
            onClick={() => setIsOpen(!isOpen)}
          >
            Menu {isOpen ? <HiX className="text-xl" /> : <HiMenu className="text-xl" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden flex justify-center mt-2">
          <div className="bg-[#0f0f0f] border border-gray-700 rounded-xl p-4 shadow-lg w-[85%] max-w-sm text-center">
            <ul className="space-y-3">
              {links.map((link, index) => (
                <li key={index}>
                  <a
                    href={`#${link.toLowerCase().replace(/[^a-z]/g, '')}`}
                    className="block text-white text-base transition duration-300 hover:text-teal-300"
                    onClick={() => setIsOpen(false)}
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
